module.exports = __webpack_public_path__ + "static/media/reposteria.eefa2c1e.svg";